import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/services/cloud-platform/page.tsx");
